import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=Press+Start+2P&family=VT323&display=swap');

  :root {
    --taskbar-height: 40px;
    --taskbar-bg: #c3c3c3;
    --desktop-bg: #008080;
    --pixel-scale: 1;
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    image-rendering: pixelated;
  }

  body {
    font-family: 'VT323', monospace;
    font-size: 16px;
    overflow: hidden;
    cursor: url('/cursors/normal.cur'), default;
  }

  h1, h2, h3, button, 
  .window-title,
  .start-button {
    font-family: 'Press Start 2P', monospace;
    font-size: 12px;
  }

  .desktop-text {
    font-family: 'VT323', monospace;
    font-size: 14px;
  }

  /* Update desktop background */
  .desktop-background {
    background: var(--desktop-bg) url('/images/davidOS-bg.svg') center/cover no-repeat fixed;
  }

  /* Custom cursors for different states */
  button, 
  [role="button"],
  a,
  .clickable {
    cursor: url('/cursors/pointer.cur'), pointer;
  }

  /* Loading cursor state */
  .loading {
    cursor: url('/cursors/loading.ani'), progress !important;
  }

  /* Custom selection color */
  ::selection {
    background: #000080;
    color: white;
  }

  /* Pixelated transition for hover effects */
  .hover-effect {
    transition: all 0.1s steps(4);
  }
`;